import React, { useEffect, useRef } from 'react';
import { Form as FinalForm } from 'react-final-form';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { Form, FieldTextInput, PrimaryButton } from '../../components';
import * as validators from '../../util/validators';
import { isChangePasswordWrongPassword } from '../../util/errors';
import css from './DeleteProfileForm.module.css';

const DeleteProfileForm = ({ onSubmit, inProgress, errorMessage, onChangePassword, changePasswordError }) => {
    const intl                      = useIntl();
    const passwordLabel             = intl.formatMessage({ id: 'DeleteProfileForm.passwordLabel' });
    const passwordPlaceholder       = intl.formatMessage({ id: 'DeleteProfileForm.passwordPlaceholder' });
    const passwordRequiredMessage   = intl.formatMessage({ id: 'DeleteProfileForm.passwordRequired' });
    const passwordFailedMessage     = intl.formatMessage({ id: 'DeleteProfileForm.passwordFailed' });
    const passwordRequired          = validators.requiredStringNoTrim(passwordRequiredMessage);
    const lastSubmittedValue        = useRef('');

    return (
        <FinalForm
            onSubmit = {values => {
                lastSubmittedValue.current = values.currentPassword;
                onSubmit(values);
            }}
            render = {({ handleSubmit, values, invalid }) => {
                const isDisabled = !values.currentPassword || invalid;
                const passwordErrorText = isChangePasswordWrongPassword(changePasswordError)
                    ? passwordFailedMessage
                    : null;

                useEffect(() => {
                    if (
                        onChangePassword &&
                        errorMessage &&
                        values.currentPassword !== '' &&
                        values.currentPassword !== lastSubmittedValue.current
                    ) {
                        onChangePassword();
                    }
                }, [values.currentPassword, errorMessage, onChangePassword]);

                return (
                    <Form onSubmit={handleSubmit} className={css.form}>
                        <div className={css.enterPassword}>
                            <FieldTextInput
                                id="currentPassword"
                                name="currentPassword"
                                type="password"
                                label={passwordLabel}
                                placeholder={passwordPlaceholder}
                                autoComplete="current-password"
                                validate={passwordRequired}
                                customErrorText={errorMessage || passwordErrorText}
                            />
                        </div>
                        <PrimaryButton
                            type="submit"
                            inProgress={inProgress}
                            disabled={isDisabled || inProgress}
                        >
                            <FormattedMessage id="DeleteProfileForm.deleteAccountButton" />
                        </PrimaryButton>
                    </Form>
                )
            }}
        />
    );
};

export default DeleteProfileForm;
